import React, { useState } from "react";
import Button from "reactstrap/lib/Button";
import moment from "moment";
import { MAX_NOTE_LENGTH } from "../helpers/constants";

const NoteDisplay = ({
  note,
  entryNumber,
  showEntryNumber,
  className = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isLongNote = note.note && note.note.length > MAX_NOTE_LENGTH;
  const displayNote =
    isLongNote && !isExpanded
      ? note.note.substring(0, MAX_NOTE_LENGTH) + "..."
      : note.note;

  return (
    <div className={`p-3 border rounded bg-light ${className}`}>
      <div className="mb-0">
        {displayNote}
        {isLongNote && (
          <Button
            color="link"
            size="sm"
            className="p-0 ml-2 text-decoration-none"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "Show less" : "Show more"}
          </Button>
        )}
      </div>
      {note.author && (
        <small className="text-muted d-block mt-2">
          {showEntryNumber && `Entry #${entryNumber} - `}
          Added by: {note.author.firstName} {note.author.lastName}
          {note.createdAt && (
            <span>
              {" "}
              on {moment(note.createdAt).format("MM/DD/YYYY, h:mm a")}
            </span>
          )}
        </small>
      )}
    </div>
  );
};

export default NoteDisplay;
